import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTbLgtMod = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "14.75 22.75 50.5 26.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(4,0) scale(3)",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M 4,16 L 8,16 L 12,8 L 16,16 L 20,16 M 10,16 L 14,16",
			stroke: "white",
			strokeWidth: 2.5,
			fill: "none"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M 4,16 L 8,16 L 12,8 L 16,16 L 20,16 M 10,16 L 14,16",
			stroke: "#ff8800",
			fill: "none"
		})]
	})
});
export default SvgTbLgtMod;
